/*! Diverse JS Scripts
* ================
* Main JS application file for AdminLTE v2. This file
*/

// Make sure jQuery has been loaded
if (typeof jQuery === 'undefined') {
    throw new Error('jQuery is required!')
}

// Start scripts
+function ($) {
    'use strict';

    // Global AJAX settings
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    // Selectize
    if ($.fn.selectize) {
        $('.selectize').selectize({
            placeholder: "Bitte wählen..."
        });

        // Selectize inline
        $('.selectize-inline').selectize({
            placeholder: "Bitte wählen...",
            inputClass: 'form-control selectize-input'
        });
    }

    // Sidebar tree
    if ($.fn.tree) {
        $('.sidebar-menu').tree({
            animationSpeed: 150
        });
    }

    // Owl Carousel 2
    if($.fn.owlCarousel) {
        $('.owl-carousel').owlCarousel({
            items: 1,
            loop: true
            // nav: true
        });
    }

    $('.training-answer').each(function () {
        var self = $(this);
        var el = $(this).find(':radio, :checkbox');
        var submit = self.parents('form').find(':submit');

        // Set pre checked item as active
        if (el[0] && el[0].checked) {
            self.addClass('active');
        }

        // Toggle "active" class on change
        el.on('change', function () {
            $('.training-answer').removeClass('active');
            self.toggleClass('active', this.checked);

            if (el[0] && el[0].checked) {
                submit.attr('disabled', false);
            } else {
                submit.attr('disabled', true);
            }
        });
    });

    /**
     * Loading overlay
     * */
    $('form.loading-overlay').on('submit', function () {
        var overlay = $(this).find('.overlay');
        var html = '<div class="overlay"><i class="fa fa-spinner fa-spin"></i></div>';

        $(this).append(html);
    });


    /**
     * Select all visible required inputs
     * and add class "required" to parent
     * */
    $(':input[required]:visible').parents('.form-group').addClass('required');


    /**
     * Nachricht nach x Millisekunden wieder ausblenden
     */
    $(".alert-autohide").each(function () {
        var delay = $(this).data('delay');

        $(this).delay(delay).fadeOut("slow", function () {
            $(this).remove();
        });
    });

}(jQuery);